import React from "react";
import Banner from "../Components/Banner";
import Features from "../Components/Feature";
import ScriptInjectSection from "../Components/ScriptInjector";

export default function Home() {
  return (
    <>
    <Banner />
    <Features />
    <ScriptInjectSection /> 
       </>
  );
}
